import PropTypes from 'prop-types'
import React, { Component } from 'react'
import TimestampInput from './TimestampInput'
import Button from './buttons/Button'
import SaveButton from './buttons/SaveButton'
import { KeyCodes } from '../constants/appConstants'

export default class MarkForm extends Component {
  static propTypes = {
    isAddingMark: PropTypes.bool,
    mark: PropTypes.object,
    onCancelClick: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    videoLength: PropTypes.number.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      time: props.mark.secondsAfterStart,
      text: props.mark.text
    }
  }

  handleTextChange = e => {
    this.setState({ text: e.target.value })
  }

  handleSubmit = e => {
    if (e.keyCode === KeyCodes.ENTER) {
      e.preventDefault()
      this.submit()
    }
  }

  submit = () =>
    this.props.onSave({
      ...this.props.mark,
      secondsAfterStart: this.state.time,
      text: this.state.text
    })

  render() {
    const { time, text } = this.state
    const { mark, onCancelClick, onSave, videoLength } = this.props

    return (
      <li className="vi-marks">
        <input
          type="text"
          value={text}
          onChange={this.handleTextChange}
          onKeyDown={this.handleSubmit}
        />
        <TimestampInput
          max={videoLength}
          onChange={time => this.setState({ time })}
          time={time}
        />
        <div className="vi-buttons">
          <SaveButton size="small" onClick={this.submit} />
          <Button role="default" size="small" onClick={onCancelClick}>
            {I18n.t('Cancel')}
          </Button>
        </div>
      </li>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/MarkForm.js